import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Fab from '@material-ui/core/Fab';
import { injectIntl } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';

const styles = theme => ({
  root: {
    textAlign: 'center',
    padding: 50,
    height: '84%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 'auto',
  },
  contentDiv: {
    textAlign: 'center',
  },
  h1: {
    margin: '20px 0',
    fontWeight: 500,
  },
  h2: {
    margin: '20px 0',
  },
  h4: {
    marginBottom: 20,
  },
  subtitle1: {
    marginBottom: 20,
  },
  fab: {
    fontSize: 25,
    marginBottom: 20,
  },
});

const ModelViewNoMatch = ({ intl, message, classes }) => {
  return (
    <Paper square className={classes.root}>
      <div className={classes.contentDiv}>
        <Divider />
        <Typography variant="h1" className={classes.h1}>
          404
        </Typography>
        <Divider />
        <Typography variant="h2" className={classes.h2}>
          {intl.formatMessage({ id: '404.somethingWentWrong' })}
        </Typography>
        <Typography variant="h4" className={classes.h4}>
          {message}
        </Typography>
        <Typography variant="subtitle1" className={classes.subtitle1}>
          {intl.formatMessage({ id: '404.desc' })}
        </Typography>
        <Fab
          variant="extended"
          size="large"
          color="primary"
          aria-label="Add"
          className={classes.fab}
          component={Link}
          to="/"
        >
          {intl.formatMessage({ id: 'home' })}
        </Fab>
        <Divider />
      </div>
    </Paper>
  );
};

ModelViewNoMatch.propTypes = {
  message: PropTypes.string.isRequired,
  classes: PropTypes.instanceOf(Object).isRequired,
}

export default withStyles(styles)(injectIntl(ModelViewNoMatch));
